import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import {DraftTextField, JsonTextField} from '../AgentJobDraftFields';
import {formatJson, parseJson} from '../../agentJobTypeUtils';

const InternalApiCallAgentJobDraft = (props) => {
  const {
    bodyJsonText,
    draftPayload,
    setBodyJsonText,
    updatePayloadField,
  } = props;

  return (
    <Stack sx={{gap: 1.25}}>
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Service')}
        onChange={updatePayloadField('serviceTarget')}
        value={draftPayload.serviceTarget}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Method')}
        onChange={updatePayloadField('method')}
        value={draftPayload.method}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Path')}
        onChange={updatePayloadField('path')}
        value={draftPayload.path}
      />
      <JsonTextField
        label={translate('case.Detail.AgentJobs.Fields.RequestBody')}
        onChange={setBodyJsonText}
        value={bodyJsonText}
      />
    </Stack>
  );
};

InternalApiCallAgentJobDraft.propTypes = {
  bodyJsonText: PropTypes.string,
  draftPayload: PropTypes.object.isRequired,
  setBodyJsonText: PropTypes.func.isRequired,
  updatePayloadField: PropTypes.func.isRequired,
};

const buildPayload = ({bodyJsonText, draftPayload}) => ({
  ...draftPayload,
  body: parseJson(bodyJsonText, translate('case.Detail.AgentJobs.Fields.RequestBody')),
});

const getDraftBody = (job) => formatJson(job.actionPayload?.body || {});

const getDraftTitle = (job) => {
  const payload = job.actionPayload || {};
  return `${payload.method || ''} ${payload.path || ''}`.trim() ||
    translate('case.Detail.AgentJobs.ActionLabels.InternalApiCall');
};

const getDraftSubtitle = (job) => {
  const payload = job.actionPayload || {};
  return [
    translate('case.Detail.AgentJobs.ActionLabels.InternalApiCall'),
    payload.serviceTarget,
  ].filter(Boolean).join(' - ');
};

const getListDetail = (job) => {
  const payload = job.actionPayload || {};

  return [
    payload.serviceTarget,
    `${payload.method || ''} ${payload.path || ''}`.trim(),
  ].filter(Boolean).join(' - ');
};

export default {
  Draft: React.memo(InternalApiCallAgentJobDraft),
  actionType: 'INTERNAL_API_CALL',
  buildPayload,
  getDraftBody,
  getDraftSubtitle,
  getDraftTitle,
  getListDetail,
  label: translate('case.Detail.AgentJobs.ActionLabels.InternalApiCall'),
};
